/** Which edge the island's quick view is pinned to. `start` is the inline start, so it follows the direction. */
export type IslandSide = 'left' | 'right' | 'center' | 'start';
export type PhysicalIslandSide = Exclude<IslandSide, 'start'>;

export function physicalIslandSide(side: IslandSide, rtl: boolean): PhysicalIslandSide {
  if (side !== 'start') return side;
  return rtl ? 'right' : 'left';
}

/**
 * The header's `justify-content` for a physical side. Flex alignment is logical, so in an RTL document
 * `flex-start` is the RIGHT edge: the value flips with the direction to keep the content on the pill's edge.
 */
export function islandHeaderJustify(side: PhysicalIslandSide, rtl: boolean): 'flex-start' | 'flex-end' | 'center' {
  if (side === 'center') return 'center';
  return (side === 'left') !== rtl ? 'flex-start' : 'flex-end';
}
